import { Controller } from 'react-hook-form';
import { Box, TextField } from '@mui/material';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';

type ComponentTypes = {
  name?: any;
  error?: any;
  row?: number;
  control?: any;
  label?: string;
  required?: boolean;
  fullWidth?: boolean;
  labelDisabled?: boolean;
  disabled?: boolean;
};

const CustomTextArea = ({
  name,
  error,
  label,
  control,
  row = 3,
  fullWidth,
  required = false,
  labelDisabled = false,
  disabled,
}: ComponentTypes) => {
  return (
    <Box style={{ width: '100%' }} position='relative'>
      {!labelDisabled && <CustomLabel htmlFor={label}>{label}</CustomLabel>}

      <Controller
        name={name}
        control={control}
        rules={{
          required: required,
        }}
        render={({ field }) => (
          <TextField
            multiline
            disabled={disabled}
            {...field}
            rows={row}
            id={label}
            value={field.value || ''}
            fullWidth={fullWidth}
            sx={{
              width: '100%',
              background: '#ffffff',
              '.css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root': {
                padding: '10px 10px',
              },
              '.Mui-disabled': {
                background: '#f0f0f0',
              },
            }}
            error={error?.[name]}
          />
        )}
      />

      <ErrorMessage error={error} name={name} />
    </Box>
  );
};

export default CustomTextArea;
